type MediaQueryListener = (event: MediaQueryListEvent) => void;

export interface MatchMediaStub {
    // Queries passed to window.matchMedia while the stub was installed.
    queries: string[];
    setMatches: (matches: boolean) => void;
    listenerCount: () => number;
    restore: () => void;
}

// setupTests polyfills matchMedia as a static `matches: false` without addEventListener,
// so mobile branches need this stub; `legacyListenersOnly` mimics Safari < 14.
export const stubMatchMedia = (
    matches: boolean,
    options: { legacyListenersOnly?: boolean } = {}
): MatchMediaStub => {
    const originalMatchMedia = window.matchMedia;
    const listeners = new Set<MediaQueryListener>();
    const queries: string[] = [];
    let currentMatches = matches;

    const modernListenerApi = {
        addEventListener: (_type: string, listener: MediaQueryListener) => {
            listeners.add(listener);
        },
        removeEventListener: (_type: string, listener: MediaQueryListener) => {
            listeners.delete(listener);
        },
    };

    window.matchMedia = ((media: string) => {
        queries.push(media);
        return {
            media,
            get matches() {
                return currentMatches;
            },
            onchange: null,
            addListener: (listener: MediaQueryListener) => {
                listeners.add(listener);
            },
            removeListener: (listener: MediaQueryListener) => {
                listeners.delete(listener);
            },
            dispatchEvent: () => true,
            ...(options.legacyListenersOnly ? {} : modernListenerApi),
        } as unknown as MediaQueryList;
    }) as typeof window.matchMedia;

    return {
        queries,
        setMatches: (next) => {
            currentMatches = next;
            listeners.forEach((listener) =>
                listener({ matches: next, media: '' } as MediaQueryListEvent)
            );
        },
        listenerCount: () => listeners.size,
        restore: () => {
            window.matchMedia = originalMatchMedia;
        },
    };
};

export const patchFetch = () => {
    const _fetch = window.fetch;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/no-explicit-any
    // @ts-ignore
    (window as unknown)['fetch'] = async (...args) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const response = await _fetch(...args);
        const url = args[0];

        if (url.toString().toLowerCase().endsWith('/c/shop/product/getproductgiftimages')) {
            const results = [
                {
                    ImageUrl:
                        'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/AMAZ002_Small_B.jpg',
                    ImageName: 'AMAZ002_Small_B.jpg',
                    ImageId: 5043,
                    FaceplateId: '',
                },
                {
                    ImageUrl:
                        'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/AMAZ002_Small_C.jpg',
                    ImageName: 'AMAZ002_Small_C.jpg',
                    ImageId: 5044,
                    FaceplateId: '',
                },
                {
                    ImageUrl:
                        'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/AMAZ002_Small_D.jpg',
                    ImageName: 'AMAZ002_Small_D.jpg',
                    ImageId: 5045,
                    FaceplateId: '',
                },
                {
                    ImageUrl:
                        'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/AMAZ002_Small_E.jpg',
                    ImageName: 'AMAZ002_Small_E.jpg',
                    ImageId: 5046,
                    FaceplateId: '',
                },
                {
                    ImageUrl:
                        'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/AMAZ002_Small_F.jpg',
                    ImageName: 'AMAZ002_Small_F.jpg',
                    ImageId: 5047,
                    FaceplateId: '',
                },
                {
                    ImageUrl:
                        'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/AMAZ002_Small_G.jpg',
                    ImageName: 'AMAZ002_Small_G.jpg',
                    ImageId: 5048,
                    FaceplateId: '',
                },
                {
                    ImageUrl:
                        'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/AMAZ002_Small_H.jpg',
                    ImageName: 'AMAZ002_Small_H.jpg',
                    ImageId: 5049,
                    FaceplateId: '',
                },
            ];

            const blob = new Blob([JSON.stringify(results)], {
                type: 'application/json',
            });

            return new Response(blob, {
                status: 200,
                statusText: 'OK',
            });
        }

        return response;
    };
};
